<template>
    <div class="item" @click="$emit('select')">
        <div style="margin-right: 21px">
            <input type="checkbox" :checked="value.selected">
        </div>
        <div style="width: 100%;">

        <h4>{{ value.name }}</h4>
        <p>
            {{ value.address_line1 }}
            <br>
            {{ value.city }}, {{ value.state ? value.state + ', ' : '' }}{{ value.postal_code }}
        </p>

        <p v-if="main_phone_number">{{ value.main_phone_number }}</p>
    </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    emits: ['select']
}
</script>

<style scoped>
.item {
    border: 1px solid #D0D5DD;
    padding: 1rem;
    margin-bottom: 1.5rem;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    cursor: pointer;
}

#alerts-app .item h4 {
    font-family: Arial;
    font-size: 20px;
    font-weight: 700;
    line-height: 23px;
    padding: 0;
    margin-bottom: 0.5rem;
}

#alerts-app .item p {
    font-family: Arial;
    font-size: 20px;
    font-weight: 400;
    line-height: 23px;
    text-align: left;
    margin-bottom: 0.5rem;
}
</style>